//******************************************************************************
// 2点間距離を計算するインスタンス組み込み用関数
// maplibreのLngLatで採用されている計算式では桁落ちするためleafletの式を借用

//******************************************************************************
// export
/**
 *
 * @param {{lng: number, lat: number}} value
 * @returns {number}
 */
export const distanceTo = function (value) {
	const rad = Math.PI / 180,
		lat1 = this.lat * rad,
		lat2 = value.lat * rad,
		sinDLat = Math.sin((value.lat - this.lat) * rad / 2),
		sinDLon = Math.sin((value.lng - this.lng) * rad / 2),
		a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon,
		c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	// leafletの半径は6371000だがmaplibreの半径を使う
	return 6371008.8 * c;
};
